// src/components/ui/checkbox.js
import React from 'react';
import { Check } from 'lucide-react';

const Checkbox = React.forwardRef(({ 
  className = '', 
  checked = false,
  onCheckedChange,
  disabled = false,
  ...props 
}, ref) => {
  const handleChange = (e) => {
    if (onCheckedChange) {
      onCheckedChange(e.target.checked);
    }
  };

  return (
    <div className="relative">
      <input
        ref={ref}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        className="sr-only"
        {...props}
      />
      <div 
        className={`
          h-4 w-4 rounded border-2 border-gray-300 flex items-center justify-center cursor-pointer transition-colors
          ${checked ? 'bg-blue-600 border-blue-600' : 'bg-white'}
          ${disabled ? 'opacity-50 cursor-not-allowed' : 'hover:border-blue-500'}
          ${className}
        `}
        onClick={() => !disabled && onCheckedChange && onCheckedChange(!checked)}
      >
        {checked && <Check className="h-3 w-3 text-white" />}
      </div>
    </div>
  );
});
Checkbox.displayName = 'Checkbox';

export { Checkbox };
